module.exports = __webpack_public_path__ + "img/about-dogs.a52a9b2b.png";